import { MISC, NP_NP, TO_BE_INITIATED, NOT_SETTLED, SETTLED } from "../constants/constants"
export const reconciliationData =
[
    {
        "Id": 1,
        "ReconciliationId": 1,
        "SettlementId": 1,
        "SettlementRefNo": "string",
        "PaymentId": 123,
        "ReconciliationItemStatusId": TO_BE_INITIATED,
        "DueDate": "2023-10-10T12:27:34.410Z",
        "Amount": {
            "Currency": "INR",
            "DiffValue": "string",
            "Value": "100"
        },
        "Comission": {
            "Currency": "INR",
            "DiffValue": "string",
            "Value": "10"
        },
        "WithholdingAmount": {
            "Currency": "INR",
            "DiffValue": "string",
            "Value": "20"
        },
        "TCS": {
            "Currency": "INR",
            "DiffValue": "string",
            "Value": "2"
        },
        "TDS": {
            "Currency": "INR",
            "DiffValue": "string",
            "Value": "3"
        },
        "CreatedOnUtc": "2023-10-10T12:27:34.410Z",
        "UpdatedOnUtc": "2023-10-10T12:27:34.410Z",
        "Remarks": "test"
    },
    {
        "Id": 2,
        "ReconciliationId": 1,
        "SettlementId": 1,
        "SettlementRefNo": "string",
        "PaymentId": 123,
        "ReconciliationItemStatusId": TO_BE_INITIATED,
        "DueDate": "2023-10-10T12:27:34.410Z",
        "Amount": {
            "Currency": "INR",
            "DiffValue": "string",
            "Value": "100"
        },
        "Comission": {
            "Currency": "INR",
            "DiffValue": "string",
            "Value": "10"
        },
        "WithholdingAmount": {
            "Currency": "INR",
            "Value": "20"
        },
        "TCS": {
            "Currency": "INR",
            "DiffValue": "string",
            "Value": "2"
        },
        "TDS": {
            "Currency": "INR",
            "DiffValue": "string",
            "Value": "3"
        },
        "CreatedOnUtc": "2023-10-10T12:27:34.410Z",
        "UpdatedOnUtc": "2023-10-10T12:27:34.410Z",     
        "Remarks": "test"
    }
]

